import { Superscript } from "@tiptap/extension-superscript"
import { htmlMarkTokenizer, parseHtmlMark, renderHtmlMark } from "../../util/markdown-html-mark"

export const SuperscriptContentExtension = Superscript.extend({
  markdownTokenName: "superscript",
  markdownTokenizer: htmlMarkTokenizer("superscript", "sup"),
  renderMarkdown: (node, helpers) => renderHtmlMark(node, helpers, "sup"),
  parseMarkdown: (token, helpers) => parseHtmlMark(token, helpers, "superscript"),
})
